export default function Instructions() {
  return(
      <p className="instructions">Drag the clue card to the correct spot in the timeline. (<a href="about.html">?</a>)</p>
      );
}

